import { render, staticRenderFns } from "./BookVideoSkelton.vue?vue&type=template&id=e9fe1df8&scoped=true&"
var script = {}
import style0 from "./BookVideoSkelton.vue?vue&type=style&index=0&id=e9fe1df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fe1df8",
  null
  
)

export default component.exports